<template>
<div class="container" style="margin: 10px auto 80px auto">	    
    <div class="row border-bottom pb-2">  
        <div class="col">
            <h3 class="display-5"><i class="text-danger fas" :class="{'fa-user': !loading && !letterLoading && !downloading, 'fa-circle-notch fa-spin': loading || letterLoading || downloading}"></i> Documents by Donor</h3>
        </div>
    </div>
    <div class="row mt-2">
        <h4>Enter one or more Lobo donor IDs</h4>
    </div>
    <div>
        <div class="form-row">
            <div class="col input-group form-label-group" :class="{'has-items': donors.length > 0}">
                <input type="text" maxlength="10" v-on:keyup.enter="addDonor()" v-model="donorID" placeholder="Enter a Lobo donor ID" class="form-control">
                <label>Enter a Lobo donor ID</label>                 
                <button type="button" :disabled="donorID.trim() == '' || !validID" v-on:click="addDonor()" class="btn btn-success"><i class="fas fa-plus"></i> Add</button>
                <button type="button" :disabled="donorID.trim() == ''" v-on:click="donorID = '';" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>                
            </div>               
        </div>
        <div class="card mb-3" v-if="donors.length">
            <ul class="list-group list-group-flush">
                <li :key="i" class="list-group-item" v-for="(d, i) in donors">
                    <span>{{d.NAME}} ({{d.DONOR_ID}})</span> 
                    <span v-if="d.ADVANCE_ID" class="badge bg-primary ms-2"><i aria-hidden="true" class="fa fa-history"></i> <strong>Advance ID</strong> {{d.ADVANCE_ID}}</span> 
                    <button type="button" v-on:click="removeDonor(i)" :disabled="letterLoading" class="float-end btn btn-sm btn-danger"><i class="fas fa-ban"></i> Remove</button>
                </li>
            </ul>
        </div> 
    </div>   
    <div class="row mt-2">
        <h4>Select a date range</h4>
    </div>    
    <div class="row mt-2">
        <div class="col-6 mb-2">            
            <v-date-picker
            mode="single"
            v-model="startDate"                  
            >
            <template v-slot="{ inputValue, inputEvents }">
                 <div class="input-group form-label-group">
                    <input type="text"
                    class="form-control"                    
                    :value="inputValue"
                    v-on="inputEvents"
                    placeholder="Enter a start date">
                     <label>Enter a start date</label> 
                    <button type="button" v-on:click.stop="startDate = null" :disabled="startDate == null || letterLoading || downloading" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>
                </div>
            </template>
            </v-date-picker>
        </div>

        <div class="col-6">
            <v-date-picker
            mode="single"
            v-model="endDate"                  
            >
            <template v-slot="{ inputValue, inputEvents }">
                 <div class="input-group form-label-group">
                    <input type="text"
                    class="form-control"                    
                    :value="inputValue"
                    v-on="inputEvents"
                    placeholder="Enter an end date">
                     <label>Enter an end date</label> 
                    <button type="button" v-on:click.stop="endDate = null" :disabled="endDate == null || letterLoading || downloading" class="btn btn-danger"><i class="fas fa-times"></i> Clear</button>
                </div>
            </template>
            </v-date-picker>                   
        </div>
    </div>

    <div class="row mt-2">
        <div class="col-6">
            <h5>Stationery and receipt options</h5>
            <div class="form-check form-switch">
                <input type="checkbox" class="form-check-input" true-value="Y" false-value="N" v-model="household" id="household">
                <label class="form-check-label" for="household">Include spouse/partner gifts (household)</label>
            </div>
            <div class="form-check form-switch">
                <input type="checkbox" v-model="stock" class="form-check-input" id="useStock">
                <label class="form-check-label" for="useStock">Create with receipt stationery</label>
                <div v-if="stock">
                    <input type="checkbox" v-model="duplicate" class="form-check-input" id="useDuplicate">
                    <label class="form-check-label" for="useDuplicate">Add "re-issue" watermark</label>
                </div>
            </div>        
        </div>
        <div class="col-6">
            <h5>Choose a file output format</h5>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="output" id="outputDocx" value="DOCX" v-model="output">
                <label class="form-check-label" for="outputDocx">.docx file</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="output" id="outputPDF" value="PDF" v-model="output">
                <label class="form-check-label" for="outputPDF">PDF file</label>
            </div>
        </div>
    </div>    

    <!--<div class="form-row mt-2">
        <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" true-value="Y" false-value="N" v-model="params.summary" id="summary">
            <label class="custom-control-label" for="summary">Create a summary receipt</label>
        </div>
    </div>    -->
    <div class="form-row mt-3">
        <button type="button" v-on:click="getDocs('ERECEIPT')" :disabled="letters.ERECEIPT == 0 || letterLoading || downloading" class="btn btn-info me-2 text-white"><i class="fas fa-file-download"></i> View {{letters.ERECEIPT}} e-receipt<span v-if="letters.ERECEIPT != 1">s</span></button>
        <button type="button" v-on:click="getDocs('DONOR')" :disabled="letters.RECEIPTS == 0 || letterLoading || downloading" class="btn btn-success me-2"><i class="fas fa-file-download"></i> Get {{letters.RECEIPTS}} receipt<span v-if="letters.RECEIPTS != 1">s</span></button>
        <button type="button" v-on:click="getDocs('MODIFICATION')" :disabled="letters.REVERSALS == 0 || letterLoading || downloading" class="btn btn-primary me-2"><i class="fas fa-file-download"></i> Get {{letters.REVERSALS}} modification<span v-if="letters.REVERSALS != 1">s</span></button>
        <button type="button" v-on:click="getDocs('STOCK')" :disabled="letters.SECURITIES == 0 || letterLoading || downloading" class="btn btn-danger me-2"><i class="fas fa-file-download"></i> Get {{letters.SECURITIES}} stock letter<span v-if="letters.SECURITIES != 1">s</span></button>
        <button type="button" v-on:click="getDocs('IRA')" :disabled="letters.IRA == 0 || letterLoading || downloading" class="btn btn-warning me-2"><i class="fas fa-file-download"></i> Get {{letters.IRA}} IRA letter<span v-if="letters.IRA != 1">s</span></button>
        <button type="button" v-on:click="getDocs('DAF')" :disabled="letters.DAF == 0 || letterLoading || downloading" class="btn btn-secondary me-2"><i class="fas fa-file-download"></i> Get {{letters.DAF}} DAF letter<span v-if="letters.DAF != 1">s</span></button>
    </div>   
    <div class="form-row mt-3">
        <button type="button" v-on:click="getDocs('SUMMARY')" :disabled="(letters.RECEIPTS == 0 && letters.REVERSALS == 0) || letterLoading || downloading" class="btn btn-dark"><i class="fas fa-file-invoice-dollar"></i> Create a summary receipt</button>
    </div>
</div>
</template>
<script>
const lettersDefault = {
    RECEIPTS: 0,
    REVERSALS: 0,
    SECURITIES: 0,
    IRA: 0,
    DAF: 0,
    ERECEIPT: 0
};
import moment from 'moment';
export default {
    data() {
        return {
            loading: false,
            letterLoading: false,
            downloading: false,
            donorID: '',
            donors: [],
            letters: lettersDefault,
            startDate: null,
            endDate: null,
            household: 'N',
            stock: false,
            duplicate: false,
            output: 'DOCX'      
        }
    },
    methods: {
        addDonor: function() {
            var _this = this;
            //No donor ID
            if (this.donorID.trim() == '') {
                return;
            } else {
                this.donorID = this.donorID.trim();
            }

            //Invalid donor ID
            if (!this.validID) {
                this.$root.setAlert(true, 'That is an invalid entity ID', 'alert-warning');
                return;
            }
            this.donorID = this.donorID.padStart(8, '0');
            //Donor ID exists
            if (this.donors.some(function(d) {                
                return d.DONOR_ID == _this.donorID;
            })) {
                _this.$root.setAlert(true, 'That entity has already been included', 'alert-warning');
                return;
            }
            
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/donor/donor.lookup.php', {
                params: {
                    'donor_id': this.donorID                    
                }
            }).then(response => {	                                		                
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {
                    if (response.data.length) {
                        this.donors.push(response.data[0]);
                        this.donorID = '';
                        this.getDonorLetters();
                    } else {
                        this.$root.setAlert(true, 'The provided entity ID does not exist', 'alert-warning');
					    return;
                    }
				}
    		}).catch(error => {
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});
        },
        removeDonor: function(ind) {
            this.donors.splice(ind, 1);          
            if (this.donors.length) {
                this.getDonorLetters();
            } else {
                this.letters = lettersDefault;
            }
        },
        getDocs: function(type) {            
            if (this.downloading) {                
                return;
            }
            this.downloading = true;
            var data = {};
            var script = '';
            var filename = '';
            var _this = this;  
            var startDate = this.startDate || null;
            var ereceipt = false;
            if (startDate > '') {
                startDate = moment(startDate).format('YYYYMMDD');
            }
            var endDate = this.endDate || null;
            if (endDate > '') {
                endDate = moment(endDate).format('YYYYMMDD');
            }     
            var donors = [];
            for (var i = 0; i < this.donors.length; i++) {
                donors.push(this.donors[i].DONOR_ID);
            }     
            switch (type) {
                case 'DONOR':
                    script = 'receipt.generate.php';
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'reversal': 'N',
                        'donors': donors,
                        'summary': 'N',
                        'household': this.household,
                        'stock': this.stock,
                        'duplicate': this.duplicate,
                        'output': this.output
                    };
                    filename = 'donor_receipts_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'donor_receipts_multiple';
                    }
                break;
                case 'SUMMARY':
                    script = 'receipt.generate.php';
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'reversal': 'N',
                        'donors': donors,
                        'summary': 'Y',
                        'household': this.household,
                        'stock': this.stock,
                        'duplicate': this.duplicate,
                        'output': this.output
                    };
                    filename = 'donor_summary_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'donor_summary_multiple';
                    }
                break;
                case 'MODIFICATION':
                    script = 'receipt.generate.php';
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'reversal': 'Y',
                        'donors': donors,
                        'summary': 'N',
                        'household': this.household,
                        'stock': this.stock,
                        'duplicate': this.duplicate,
                        'output': this.output
                    };
                    filename = 'donor_modifications_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'donor_modifications_multiple';
                    }
                break;
                case 'STOCK':
                    script = 'stockLetter.generate.php',
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'donors': donors,                        
                        'household': this.household,
                        'output': this.output
                    };
                    filename = 'stock_letters_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'stock_letters_multiple';
                    }
                break;
                case 'IRA':
                    script = 'iraLetter.generate.php',
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'donors': donors,                        
                        'household': this.household,
                        'output': this.output
                    };
                    filename = 'IRA_letters_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'IRA_letters_multiple';
                    }
                break;
                case 'DAF':
                    script = 'dafLetter.generate.php',
                    data = {
                        'start_date': startDate,
                        'stop_date': endDate,
                        'type': 'DONOR',
                        'donors': donors,                        
                        'household': this.household,
                        'output': this.output
                    };
                    filename = 'DAF_letters_'+this.donors[0].DONOR_ID;
                    if (this.donors.length > 1) {
                        filename = 'IRA_letters_multiple';
                    }
                break;
                case 'ERECEIPT':
                    ereceipt = true;                    
                    this.$router.push({ name: 'ereceipt', params: { type: 'donor', param: donors.join(), startDate: startDate, endDate: endDate } });
                break;
            }                       
            if (!ereceipt) { 
                this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/'+script, {
                    responseType: 'blob',
                    params: data
                }).then(response => {	         
                    if (response.data.type == 'text/html') {
                        var d = new Blob([response.data]);
                        var r = new FileReader();
                        r.addEventListener('loadend', (e) => {
                            const err = e.target.result;
                            _this.$root.setAlert(true, err, 'alert-danger');
                        });
                        r.readAsText(d);                                        
                        _this.downloading = false;
                        return;
                    }                                  		                                
                    if (response.data.error) {
                        _this.$root.setAlert(true, response.data.error, 'alert-danger');
                        _this.downloading = false;
                        return;
                    } else {                       
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', filename+'.'+this.output.toLowerCase());
                        document.body.appendChild(link);
                        link.click();
                        link.remove();
                        _this.downloading = false;			        
                    }
                }).catch(error => {
                    _this.$root.setAlert(true, error, 'alert-danger');
                    _this.downloading = false;
                    return;
                });
            }
        },
        getDonorLetters: function() {
            this.letterLoading = true;
            var _this = this;
            var startDate = this.startDate;
            if (startDate > '') {
                startDate = moment(startDate).format('YYYYMMDD');
            }
            var endDate = this.endDate;
            if (endDate > '') {
                endDate = moment(endDate).format('YYYYMMDD');
            }
            var donorIDs = [];            
            for (var i = 0; i < this.donors.length; i++) {
                donorIDs.push(this.donors[i].DONOR_ID);
            }            
            var params = {
                'donors': donorIDs,
                'start_date': startDate,                
                'end_date': endDate              
            };                      
            this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/donor/letter.lookup.php', {
                params: params
            }).then(response => {	                  
                _this.letterLoading = false;                   
				if (response.data.error) {
					this.$root.setAlert(true, response.data.error, 'alert-danger');
					return;
				} else {
                    if (response.data.length) {                        
                        this.letters = response.data[0][0];
                    } else {
                        this.$root.setAlert(true, 'The provided entity ID does not exist', 'alert-warning');
					    return;
                    }
				}
    		}).catch(error => {
                _this.letterLoading = false;
				this.$root.setAlert(true, error, 'alert-danger');
				return;
    		});
        }
    },
    computed: {
        validID: function() {            
            return this.donorID.match(/^[0-9]*$/g);
        }
    },
    watch: {
        'startDate': function(newVal, oldVal) {
            if (oldVal != newVal && this.donors.length) {
                this.getDonorLetters();
            }
        },
        'endDate': function(newVal, oldVal) {
            if (oldVal != newVal && this.donors.length) {
                this.getDonorLetters();
            }
        }        
    }
}
</script>
<style scoped>
.has-items .form-control, .has-items .btn {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
}

.card {
    border-top: none;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
.btn-success.dropdown-toggle {
    border-start-color: rgb(25, 105, 44);
}

a.dropdown-item {
    cursor: pointer;
}

a.dropdown-item:active, a.dropdown-item:active i {
    color: #FFF !important;
}
</style>
